module.exports = __webpack_public_path__ + "static/media/giphy_animated.fbbb1831.gif";